import React from 'react';
import { resGridStatus1, resGridStatus2, resGridStatus3, resGridStatus4, resGridStatus5, resGridHistory, resGridNotesCheck, resGridNotes, resGridConfidential, resGridTemplateEmpty, resGridImageResult, resButtonsPin, resButtonsRetransm, resGridStatus0, resMail, resWhatsApp, multilineIcon } from '../../../../../images/icons';
import { useAppDispatch, useAppSelector } from '../../../../../contexts/hooks';
import { Button, Popover, Tooltip } from 'devextreme-react';
import moment from 'moment';
import { dxPopoverAnimation } from 'devextreme/ui/popover';
import { ETypeExternalExportResult, ResultEstadoResult, SysIResultados } from '../../../../../types/types.orders';
import { ResultTypeResult } from '../../../../../types/types.analitos';
import { showModalHistory, showModalNotes } from '../../../../../contexts/slices/orders';
import { newToast } from '../../../..';
import { SysI_CodBarrasImpresoras } from '../../../../../types/types.barcodes';
import { useApiBarcodes } from '../../../../../api/api.barcodes';
import { setModalBarcodePrintersVisible } from '../../../../../contexts/slices/config';

const animationConfig: dxPopoverAnimation = {
  show: {
    type: 'pop',
    from: {
      scale: 0,
    },
    to: {
      scale: 1,
    },
  },
  hide: {
    type: 'fade',
    from: 1,
    to: 0,
  },
};

export const useApiFunctionsResult = () => {
  const ModuleTracking: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.find((x) => x.Cgn_Nombre === 'ModuleTracking')?.Cgn_Resultado) || 'false');
  const Prm_Res_Conf = useAppSelector((x) => x.userInfo.Permissions?.Prm_Res_Conf);
  let lstValRefers = useAppSelector((x) => x.configuration.Data?.AnalitosValoresRef);
  const { getPrinters, PrintBarcodeLabels } = useApiBarcodes();
  const dispatch = useAppDispatch();
  const ModuleBarcode: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleBarcode')[0].Cgn_Resultado) || 'false');

  // Función para extraer el valor numérico de strings como ">1000" o "<500"
  const extractNumericValue = (value: string): number | null => {
    if (!value) return null;
    const cleaned = String(value).trim();
    // Remover > o < del inicio y convertir a número
    const numStr = cleaned.replace(/^[><]\s*/, '');
    const num = parseFloat(numStr);
    return isNaN(num) ? null : num;
  };

  // Función para sanitizar cualquier valor que pueda ser un objeto
  const sanitizeForDisplay = (val: any): string => {
    if (val === null || val === undefined) return '';
    if (typeof val === 'object') return JSON.stringify(val);
    return String(val);
  };

  //Renderiza la celda de Estados
  const handleStatusResult = (data?: any, state?: ResultEstadoResult) => {
    let stateHandler = ResultEstadoResult.SinResultado;
    const rowData: SysIResultados = data.data;
    if (state) {
      stateHandler = state;
    } else {
      stateHandler = rowData.Res_Estado;
    }
    switch (stateHandler) {
      case ResultEstadoResult.SinResultado:
      default:
        return (
          <div>
            <img src={resGridStatus1} alt='Sin resultados' id={`SinResult_${rowData.Res_Id}`} />
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#SinResult_${rowData.Res_Id}`}>
              Analito sin resultados
            </Tooltip>
          </div>
        );
      case ResultEstadoResult.ConResultado:
        return (
          <div>
            <img src={resGridStatus2} alt='Con resultado sin validar' id={`ConResultado_${rowData.Res_Id}`} />
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#ConResultado_${rowData.Res_Id}`}>
              Analito con resultados
            </Tooltip>
          </div>
        );
      case ResultEstadoResult.Validado:
        return (
          <div>
            <img src={resGridStatus3} alt='Validado' id={`SinResult_${rowData.Res_Id}`} />
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#SinResult_${rowData.Res_Id}`}>
              Analito validado: {moment(rowData.Res_FechaValidacion).format('DD/MM/YYYY hh:mm a') || ''}
            </Tooltip>
          </div>
        );
      case ResultEstadoResult.Impreso:
        return (
          <div>
            <img src={resGridStatus4} alt='Impresa' id={`SinResult_${rowData.Res_Id}`} />
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#SinResult_${rowData.Res_Id}`}>
              Analito impreso : {moment(rowData.Res_FechaImpresion).format('DD/MM/YYYY hh:mm a') || ''}
            </Tooltip>
          </div>
        );
      case ResultEstadoResult.OtrasFuentes:
        if (!rowData.Res_EnviadoOtrasFuentes) {
          return (
            <div>
              <img src={resButtonsRetransm} alt='En otras fuentes' id={`SinResult_${rowData.Res_Id}`} />
              <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#SinResult_${rowData.Res_Id}`}>
                En espera para ser reenviado a fuentes externas
              </Tooltip>
            </div>
          );
        }
        return (
          <div>
            <img src={getImageByOtherFonts(rowData.Res_EnviadoOtrasFuentes)} alt='En otras fuentes' id={`SinResult_${rowData.Res_Id}`} />
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#SinResult_${rowData.Res_Id}`}>
              {getETypeExternalExportResult(rowData.Res_EnviadoOtrasFuentes)}: {moment(rowData.Res_FechaEnviadoOtrasFuentes).format('DD/MM/YYYY hh:mm a') || ''}
            </Tooltip>
          </div>
        );
      case ResultEstadoResult.ValidadoBlanco:
        return (
          <div>
            <img src={resGridStatus0} alt='Fijado como resultado en blanco' id={`SinResult_${rowData.Res_Id}`} />
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#SinResult_${rowData.Res_Id}`}>
              Analito con resultado fijado en blanco: {moment(rowData.Res_FechaImpresion).format('DD/MM/YYYY hh:mm a') || ''}
            </Tooltip>
          </div>
        );
    }
  };

  const getImageByOtherFonts = (type: ETypeExternalExportResult) => {
    switch (type) {
      case ETypeExternalExportResult.CorreoElectronico:
        return resMail;
      case ETypeExternalExportResult.PaginaWebResultados:
        return resGridStatus5;
      case ETypeExternalExportResult.HistoriaClinica:
        return resGridStatus5;
      case ETypeExternalExportResult.SistemaExterno:
        return resGridStatus5;
      case ETypeExternalExportResult.WhatsApp:
        return resWhatsApp;
      default:
        return resButtonsRetransm;
    }
  };

  const getETypeExternalExportResult = (Fuente: ETypeExternalExportResult) => {
    switch (Fuente) {
      case ETypeExternalExportResult.CorreoElectronico:
        return 'Correo Electronico';
      case ETypeExternalExportResult.PaginaWebResultados:
        return 'Pagina Web Resultados';
      case ETypeExternalExportResult.HistoriaClinica:
        return 'Historia Clinica';
      case ETypeExternalExportResult.SistemaExterno:
        return 'Sistema Externo';
      case ETypeExternalExportResult.WhatsApp:
        return 'WhatsApp';
      default:
        return 'Fuente no definida';
    }
  };

  //#region EVENTOS

  //Evento clic para la celda de historico
  const handleHistoryClick = (data: SysIResultados) => {
    if (data.Estudio.Es_Confidencial && !Prm_Res_Conf) {
      newToast('WARNING', 'No cuenta con permisos para ver resultados confidenciales', 5);
      return;
    }
    dispatch(showModalHistory({ Visible: true, An_Id: data.Res_An_Id, An_Nombre: data.Analito.An_Nombre, Res_Estado: data.Res_Estado, Res_Id: data.Res_Id, Res_Resultado: data.Res_NotaValidacion, An_Tr_Id: data.Analito.An_Tr_Id, Update: false, Pc_Id: data.Orden.Ord_Pc_Id }));
  };

  const handlePrintBarcodesLabel = async (idOrden: number, lstIdsEstudios?: number[]) => {
    if (!ModuleBarcode) {
      return;
    }
    //Verificar si tenemos en localStorage una impresora configurada.
    const printerData = localStorage.getItem('defaultPrinter');
    let printer: SysI_CodBarrasImpresoras | undefined;
    if (printerData) {
      printer = JSON.parse(printerData);
      if (printer) {
        PrintBarcodeLabels({ IdOrden: idOrden, printer: printer, LstIdsEstudios: lstIdsEstudios });
      }
    } else {
      const printers = await getPrinters();
      if (printers?.length === 0) {
      } else if (printers?.length === 1) {
        //Seleccionar una impresora como predeterminada
        localStorage.setItem('defaultPrinter', JSON.stringify(printers[0]));
        printer = printers[0];
        newToast('INFO', `Se ha establecido la impresora '${printer.Cbp_Nombre}' como predeterminada.`, 5);
        if (printer) {
          PrintBarcodeLabels({ IdOrden: idOrden, printer: printer, LstIdsEstudios: lstIdsEstudios });
        }
      } else {
        //Mostrar modal de varias impresoras
        dispatch(setModalBarcodePrintersVisible(true));
        return;
      }
    }
  };

  //Evento clic para la celda de historico
  const handleHistoryNotesValidation = (data: SysIResultados) => {
    dispatch(showModalNotes({ Visible: true, An_Id: data.Res_An_Id, An_Nombre: data.Analito.An_Nombre, Res_Estado: data.Res_Estado, Res_Id: data.Res_Id, Res_Resultado: data.Res_NotaValidacion, Update: false, Pc_Id: data.Orden.Ord_Pc_Id }));
  };
  //#endregion
  //Renderiza la celda de históricos
  const handleHistory = (data) => {
    const rowData: SysIResultados = data.data;
    return (
      <div>
        <img
          id={`historyImg${rowData.Res_Id}`}
          className='imgClick'
          src={resGridHistory}
          alt='Evolutivo paciente'
          onClick={() => {
            handleHistoryClick(rowData);
          }}
        />
        <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#historyImg${rowData.Res_Id}`}>
          Evolutivo paciente
        </Tooltip>
      </div>
    );
  };

  //Renderiza la celda de muestras
  const handleSample = (data) => {
    const rowData: SysIResultados = data.data;

    // Solo añadiremos un estilo para el contenedor principal para centrarlo
    const cellStyle: React.CSSProperties = {
      display: 'flex',
      marginLeft: 10,
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    };

    return (
      <div style={cellStyle}>
        <div className='tube-container' id={`tmSample${rowData.Res_An_Id}`} key={rowData.Res_An_Id}>
          <div className='test-tube'>
            <div className='liquid' style={{ backgroundColor: rowData.Analito.TipoMuestra.Tm_Color || '#888' }}></div>
          </div>
          <div className='warning-icon'>{ModuleTracking && !rowData.Res_MuestraTrackedada && '!'}</div>

          <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#tmSample${rowData.Res_An_Id}`}>
            {rowData.Analito.TipoMuestra.Tm_Nombre}
            {ModuleTracking && !rowData.Res_MuestraTrackedada && <p>(Muestra sin tracking)</p>}
          </Tooltip>
        </div>
      </div>
    );
  };

  //Renderiza la celda de resultado anterior
  const handleAnt = (data) => {
    const rowData: SysIResultados = data.data;
    //Validamos los confidenciales
    if (rowData.Estudio.Es_Confidencial && !Prm_Res_Conf) {
      return (
        <div>
          <img src={resGridConfidential} id={`ConfidentialAnt${rowData.Res_Id}`} alt='Muestra sin tracking' />
          <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#ConfidentialAnt${rowData.Res_Id}`}>
            Resultado confidencial
          </Tooltip>
        </div>
      );
    }
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.IMAGEN) {
      return <div></div>;
    }

    if (rowData.Analito.An_Tr_Id === ResultTypeResult.PLANTILLA) {
      let result = [];
      if (rowData.Res_ResultadoAnterior && !rowData.Res_ResultadoAnterior.includes('||ADJUNTO||')) {
        result = JSON.parse(rowData.Res_ResultadoAnterior);
      }
      return (
        <div>
          <Button id={`pltAnt${rowData.Res_An_Id}`} icon={resGridTemplateEmpty} />
          <Tooltip target={`#pltAnt${rowData.Res_An_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
            <div>
              {Array.isArray(result) &&
                result.map((x: any, index: number) => {
                  const groupKey = sanitizeForDisplay(x.Group) || `group-${index}`;
                  const groupTitle = sanitizeForDisplay(x.Group) || 'Sin nombre';

                  return React.createElement('div', { key: groupKey, className: 'tooltip-content' }, [
                    React.createElement('h6', { key: `title-${index}`, className: 'tooltip-title' }, groupTitle),
                    ...(Array.isArray(x.Items)
                      ? x.Items.map((y: any, itemIndex: number) => {
                          const itemKey = sanitizeForDisplay(y.Key) || `item-${index}-${itemIndex}`;
                          const itemLabel = sanitizeForDisplay(y.Label) || '';
                          const itemValue = sanitizeForDisplay(y.Value);

                          return React.createElement('p', { key: itemKey, className: 'tooltip-item' }, [React.createElement('strong', { key: `item-label-${itemKey}` }, `  ${itemLabel}: `), React.createElement('span', { key: `item-value-${itemKey}` }, itemValue)]);
                        })
                      : []),
                  ]);
                })}
            </div>
          </Tooltip>
        </div>
      );
    }

    if (rowData.Analito.An_Tr_Id === ResultTypeResult.MULTILINEA) {
      const textContent = rowData.Res_ResultadoAnterior || '';
      if (!textContent) {
        return <div></div>;
      }
      return (
        <div>
          <Button id={`multiAnt${rowData.Res_An_Id}`} icon={multilineIcon} />
          <Tooltip target={`#multiAnt${rowData.Res_An_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
            <div style={{ maxWidth: '600px', maxHeight: '60vh', overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', textAlign: 'left' }}>
              {textContent}
            </div>
          </Tooltip>
        </div>
      );
    }

    if (rowData.Analito.An_Tr_Id === ResultTypeResult.IMAGENESDX) {
      return <Button icon={resGridTemplateEmpty} />;
    }

    return (
      <div id={`DateAnterior${rowData.Res_Id}`}>
        {sanitizeForDisplay(rowData.Res_ResultadoAnterior)}
        {rowData.Res_FechaResultadoAnterior && (
          <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#DateAnterior${rowData.Res_Id}`}>
            {moment(rowData.Res_FechaResultadoAnterior).format('YYYY/MM/DD HH:mm a') || ''}
          </Tooltip>
        )}
      </div>
    );
  };

  //Renderiza la celda de resultado previo 1
  const handlePreview1 = (data) => {
    const rowData: SysIResultados = data.data;
    //Validamos los confidenciales
    if (rowData.Estudio.Es_Confidencial && !Prm_Res_Conf) {
      return (
        <div>
          <img src={resGridConfidential} id={`ConfidentialPrev1${rowData.Res_Id}`} alt='Muestra sin tracking' />
          <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#ConfidentialPrev1${rowData.Res_Id}`}>
            Resultado confidencial
          </Tooltip>
        </div>
      );
    }

    //Validamos que si el tipo de resultado es plantilla
    if (rowData.Analito.An_Tr_Id === 4) {
      return <Button icon={resGridTemplateEmpty} />;
    }

    //Validar si el tipo de resultado es imagen
    if (rowData.Analito.An_Tr_Id === 7) {
      return <Button icon={resGridImageResult} />;
    }

    //Validar si el tipo de resultado es imágenes DX
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.IMAGENESDX) {
      return <Button icon={resGridTemplateEmpty} />;
    }

    //Validar si el tipo de resultado es multilínea
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.MULTILINEA) {
      const textContent = rowData.Res_ResultadoPrevio1 || '';
      if (!textContent) {
        return <div></div>;
      }
      return (
        <div>
          <Button id={`multiPrev1${rowData.Res_An_Id}`} icon={multilineIcon} />
          <Tooltip target={`#multiPrev1${rowData.Res_An_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
            <div style={{ maxWidth: '600px', maxHeight: '60vh', overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', textAlign: 'left' }}>
              {textContent}
            </div>
          </Tooltip>
        </div>
      );
    }

    return (
      <div>
        <div id={`DetailsPrev1${rowData.Res_Id}`} className='imgClick'>
          {sanitizeForDisplay(rowData.Res_ResultadoPrevio1)}
        </div>
        <Popover target={`#DetailsPrev1${rowData.Res_Id}`} animation={animationConfig} showEvent='click' position='left' title='Resultado previo 1' showTitle={true} width={300} shading={true} shadingColor='rgba(0, 0, 0, 0.5)'>
          <p>
            <strong>Resultado: </strong> {sanitizeForDisplay(rowData.Res_ResultadoPrevio1)}
          </p>
          <p>
            <strong>Fecha: </strong> {rowData.Res_FechaPrevio1 ? moment(rowData.Res_FechaPrevio1).format('YYYY/MM/DD HH:mm a') : ''}
          </p>
          {rowData.Res_OrdenPrevio1 && <Button text='Ver orden' type='default' stylingMode='contained' />}
        </Popover>
      </div>
    );
  };

  //Renderiza la celda de resultado previo 2
  const handlePreview2 = (data) => {
    const rowData: SysIResultados = data.data;
    //Validamos los confidenciales
    if (rowData.Estudio.Es_Confidencial && !Prm_Res_Conf) {
      return (
        <div>
          <img src={resGridConfidential} id={`ConfidentialPrev2${rowData.Res_Id}`} alt='Muestra sin tracking' />
          <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#ConfidentialPrev2${rowData.Res_Id}`}>
            Resultado confidencial
          </Tooltip>
        </div>
      );
    }

    //Validamos que si el tipo de resultado es plantilla
    if (rowData.Analito.An_Tr_Id === 4) {
      return <Button icon={resGridTemplateEmpty} />;
    }

    //Validar si el tipo de resultado es imagen
    if (rowData.Analito.An_Tr_Id === 7) {
      return <Button icon={resGridImageResult} />;
    }

    //Validar si el tipo de resultado es imágenes DX
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.IMAGENESDX) {
      return <Button icon={resGridTemplateEmpty} />;
    }

    //Validar si el tipo de resultado es multilínea
    if (rowData.Analito.An_Tr_Id === ResultTypeResult.MULTILINEA) {
      const textContent = rowData.Res_ResultadoPrevio2 || '';
      if (!textContent) {
        return <div></div>;
      }
      return (
        <div>
          <Button id={`multiPrev2${rowData.Res_An_Id}`} icon={multilineIcon} />
          <Tooltip target={`#multiPrev2${rowData.Res_An_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
            <div style={{ maxWidth: '600px', maxHeight: '60vh', overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', textAlign: 'left' }}>
              {textContent}
            </div>
          </Tooltip>
        </div>
      );
    }

    return (
      <div>
        <div id={`DetailsPrev2${rowData.Res_Id}`} className='imgClick'>
          {sanitizeForDisplay(rowData.Res_ResultadoPrevio2)}
        </div>
        <Popover target={`#DetailsPrev2${rowData.Res_Id}`} animation={animationConfig} showEvent='click' position='left' title='Resultado previo 2' showTitle={true} width={300} shading={true} shadingColor='rgba(0, 0, 0, 0.5)'>
          <p>
            <strong>Resultado: </strong> {sanitizeForDisplay(rowData.Res_ResultadoPrevio2)}
          </p>
          <p>
            <strong>Fecha: </strong> {rowData.Res_FechaPrevio2 ? moment(rowData.Res_FechaPrevio2).format('YYYY/MM/DD HH:mm a') : ''}
          </p>
          {rowData.Res_OrdenPrevio2 && <Button text='Ver orden' type='default' stylingMode='contained' />}
        </Popover>
      </div>
    );
  };

  //Renderiza la celda de valores de referencia
  const handleValRef = (data) => {
    const rowData: SysIResultados = data.data;
    switch (rowData.Analito.An_Tr_Id) {
      case ResultTypeResult.NUMERICO:
      case ResultTypeResult.FORMULA:
        return `${rowData.Res_ValRefMin || 0} - ${rowData.Res_ValRefMax || 0}`;
      case 2:
        return ``;
      case 3:
        return;
      case 4:
        return;
      case ResultTypeResult.TEXTUAL:
      case ResultTypeResult.LISTA:
      case ResultTypeResult.AUTOCOMPLETAR:
        return `${rowData.Analito.An_ValRefText}`;
      default:
        return;
    }
  };

  //Renderiza la celda de Notas
  const handleNote = (data) => {
    const rowData: SysIResultados = data.data;
    if (rowData.Res_NotaValidacion) {
      return (
        <div>
          <img
            id={`noteImg${rowData.Res_Id}`}
            className='imgClick'
            src={resGridNotesCheck}
            onClick={() => {
              handleHistoryNotesValidation(rowData);
            }}
            alt='Contiene notas de validación'
          />
          <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#noteImg${rowData.Res_Id}`}>
            Contiene notas de validación
          </Tooltip>
        </div>
      );
    }
    return (
      <div>
        <img
          id={`noteImg${rowData.Res_Id}`}
          className='imgClick'
          src={resGridNotes}
          onClick={() => {
            handleHistoryNotesValidation(rowData);
          }}
          alt='Notas de validación'
        />
        <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position='right' target={`#noteImg${rowData.Res_Id}`}>
          Notas de validación
        </Tooltip>
      </div>
    );
  };

  //Valida los valores absurdos y alarmas
  const checkAlarmAndAburd = (rowData: SysIResultados) => {
    const lstValRef = lstValRefers?.find((x) => x.Avr_Sd_Id === rowData?.Orden.Ord_Sd_Id && x.Avr_An_Id === rowData?.Res_An_Id);

    if (rowData?.Analito.An_Tr_Id === ResultTypeResult.NUMERICO || rowData?.Analito.An_Tr_Id === ResultTypeResult.FORMULA) {
      //Primero consultamos si el analito contiene valores absurdos
      if (!rowData?.Res_Resultado || rowData?.Res_Resultado.includes('||ADJUNTO||')) {
        return '';
      }
      if (lstValRef) {
        // Extraer el valor numérico (manejar casos como >1000 o <500)
        const resultString = String(rowData.Res_Resultado).trim();
        const numericValue = extractNumericValue(resultString);
        if (numericValue === null || isNaN(numericValue)) {
          return '';
        }

        // Detectar si tiene símbolo de comparación
        const hasGreaterThan = resultString.startsWith('>');
        const hasLessThan = resultString.startsWith('<');

        //Validamos primero los absurdos
        //Validamos que los valores absurdos sean diferente de 0 y null
        if (lstValRef.Avr_MinimoAbsurdo !== null && lstValRef.Avr_MaximoAbsurdo !== null) {
          if (lstValRef.Avr_MinimoAbsurdo !== 0 || lstValRef.Avr_MaximoAbsurdo !== 0) {
            // Si tiene >, comparar con máximo absurdo
            if (hasGreaterThan) {
              if (numericValue > lstValRef.Avr_MaximoAbsurdo) {
                return 'result-absurd-lbl';
              }
            }
            // Si tiene <, comparar con mínimo absurdo
            else if (hasLessThan) {
              if (numericValue < lstValRef.Avr_MinimoAbsurdo) {
                return 'result-absurd-lbl';
              }
            }
            // Sin símbolos, comparación normal
            else {
              if (numericValue < lstValRef.Avr_MinimoAbsurdo || numericValue > lstValRef.Avr_MaximoAbsurdo) {
                return 'result-absurd-lbl';
              }
            }
          }
        }
        //Luego validamos las alarmas
        if (lstValRef.Avr_MinimoAlarma !== null && lstValRef.Avr_MaximoAlarma !== null) {
          if (lstValRef.Avr_MinimoAlarma !== 0 || lstValRef.Avr_MaximoAlarma !== 0) {
            // Si tiene >, comparar con máximo alarma
            if (hasGreaterThan) {
              if (numericValue > lstValRef.Avr_MaximoAlarma) {
                return 'result-alarm-lbl';
              }
            }
            // Si tiene <, comparar con mínimo alarma
            else if (hasLessThan) {
              if (numericValue < lstValRef.Avr_MinimoAlarma) {
                return 'result-alarm-lbl';
              }
            }
            // Sin símbolos, comparación normal
            else {
              if (numericValue < lstValRef.Avr_MinimoAlarma || numericValue > lstValRef.Avr_MaximoAlarma) {
                return 'result-alarm-lbl';
              }
            }
          }
        }
      }
    }

    // Validar resultados textuales con valor crítico
    if ((rowData?.Analito.An_Tr_Id === ResultTypeResult.TEXTUAL || rowData?.Analito.An_Tr_Id === ResultTypeResult.AUTOCOMPLETAR || rowData?.Analito.An_Tr_Id === ResultTypeResult.LISTA) && rowData.Analito.An_ValCritico && rowData.Analito.An_ValCritico?.toUpperCase().trim() === rowData.Res_Resultado?.toUpperCase().trim()) {
      const hasSpecialChars = /[^\w\s]/.test(rowData.Analito.An_ValCritico);
      if (!hasSpecialChars) {
        return 'result-absurd-lbl';
      }
    }

    return '';
  };

  //Valida los valores absurdos y alarmas
  const checkAlarmAndAburdNoLabel = (rowData: SysIResultados) => {
    const lstValRef = lstValRefers?.find((x) => x.Avr_Sd_Id === rowData?.Orden.Ord_Sd_Id && x.Avr_An_Id === rowData?.Res_An_Id);
    if (rowData?.Analito.An_Tr_Id === 1 || rowData?.Analito.An_Tr_Id === 3) {
      //Primero consultamos si el analito contiene valores absurdos
      if (!rowData?.Res_Resultado) {
        return '';
      }
      if (lstValRef) {
        // Extraer el valor numérico (manejar casos como >1000 o <500)
        const resultString = String(rowData.Res_Resultado).trim();
        const numericValue = extractNumericValue(resultString);
        if (numericValue === null || isNaN(numericValue)) {
          return '';
        }

        // Detectar si tiene símbolo de comparación
        const hasGreaterThan = resultString.startsWith('>');
        const hasLessThan = resultString.startsWith('<');

        //Validamos primero los absurdos
        //Validamos que los valores absurdos sean diferente de 0 y null
        if (lstValRef.Avr_MinimoAbsurdo !== null && lstValRef.Avr_MaximoAbsurdo !== null) {
          if (lstValRef.Avr_MinimoAbsurdo !== 0 || lstValRef.Avr_MaximoAbsurdo !== 0) {
            // Si tiene >, comparar con máximo absurdo
            if (hasGreaterThan) {
              if (numericValue > lstValRef.Avr_MaximoAbsurdo) {
                return true;
              }
            }
            // Si tiene <, comparar con mínimo absurdo
            else if (hasLessThan) {
              if (numericValue < lstValRef.Avr_MinimoAbsurdo) {
                return true;
              }
            }
            // Sin símbolos, comparación normal
            else {
              if (numericValue < lstValRef.Avr_MinimoAbsurdo || numericValue > lstValRef.Avr_MaximoAbsurdo) {
                return true;
              }
            }
          }
        }
        //Luego validamos las alarmas
        if (lstValRef.Avr_MinimoAlarma !== null && lstValRef.Avr_MaximoAlarma !== null) {
          if (lstValRef.Avr_MinimoAlarma !== 0 || lstValRef.Avr_MaximoAlarma !== 0) {
            // Si tiene >, comparar con máximo alarma
            if (hasGreaterThan) {
              if (numericValue > lstValRef.Avr_MaximoAlarma) {
                return true;
              }
            }
            // Si tiene <, comparar con mínimo alarma
            else if (hasLessThan) {
              if (numericValue < lstValRef.Avr_MinimoAlarma) {
                return true;
              }
            }
            // Sin símbolos, comparación normal
            else {
              if (numericValue < lstValRef.Avr_MinimoAlarma || numericValue > lstValRef.Avr_MaximoAlarma) {
                return true;
              }
            }
          }
        }
      }
    }
    return '';
  };

  function isNotEmpty(value) {
    return value !== undefined && value !== null && value !== '';
  }

  return { handleHistory, handleSample, handleNote, handleStatusResult, handleValRef, handleAnt, handlePreview2, handlePreview1, checkAlarmAndAburd, checkAlarmAndAburdNoLabel, isNotEmpty, handlePrintBarcodesLabel };
};
